import facebook from '../assets/facebook.svg';
import twitter from '../assets/twitter.svg';
import youtube from '../assets/youtube.svg';
import instagram from '../assets/instagram.svg';
export default {
  facebook: facebook,
  twitter: twitter,
  youtube: youtube,
  instagram: instagram
};